// Layout.jsx
import React, { useEffect, useRef } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Section1 from "../Section/Section1/Section1";
import Section2 from "../Section/Section2/Section2";
import Section3 from "../Section/Section3/Section3";
import Section4 from "../Section/Section4.jsx/Section4";
import CustomCard from "../Section/Section7/Section7";
import Section8 from "../Section/Section8/Section8";
import Section8M from "../Section/Section8/Section8M";
import Section8Main from "../Section/Section8/Section8Main";
import MainSection3 from "../Section/ThirdMainSection/MainSection3";
import MainSection4 from "../Section/FourthMainSection/MainSection4";
import MainSection2 from "../Section/SecondMainSection/MainSection2";
import VideoCard from "../Section/Section10/Section10";
import Section11 from "../Section/Section11/Section11";
import SticyHeader from "../Section/SticyHeader/SticyHeader";
import CardMotion from "../Section/CardMotion/CardMotion";
import FAQList from "../Section/QuestionAnswerSection/Section12";
import Section13 from "../Section/QuestionAnswerSection/Section13";
import SlidingStack from "../Section/TestSection/SectionTest";
import CardSection from "../Section/FourthMainSection/MobileCardsSection/CardSection";
import CardSectionDesk from "../Section/FourthMainSection/DesktopCardSection/CardSectionDesk";
import CardSliderSection from "../Section/CardsSliderSection/CardSliderSection";
import MasonryLayout from "../Section/CardsSliderSection/MansoryLayout";
import CombineMansorySlider from "../Section/CardsSliderSection/CombineMansorySlider";
import TestSection4 from "../Section/Section4.jsx/CardSliding/TestSection4";
import Section14 from "../Section/QuestionAnswerSection/Section14";
import DesignCards from "../Section/Section4.jsx/CardSliding/DesignCards";
import SwipeCards from "../Section/Section4.jsx/CardSliding/SwipeCards";
import Section15 from "../Section/Section15/Section15";
import CardTesting from "../Section/ThirdMainSection/StackingCardsScrollingEffect/CardTesting";
import Section6 from "../Section/FourthMainSection/Section6";
import AnimatedCounterComponent from "../Section/FourthMainSection/AnimatedCounterComponent";
import SliderComponent from "../Section/SliderComponent/SliderComponent";
import Introduction101 from "../Section/ThirdMainSection/IntroSection/Introduction101";
import SliderComponent2 from "../Section/SliderComponent/SliderComponent2";
import PulseAnimation2 from "../Section/SliderComponent/PulseAnimation2";
import Section101 from "../Section/Section1/Section101";

import ConnectedBox from "../Section/BorderAnimatin/ConnectedBox";
import ClockWithPopup from "../Section/WatchAnimation/ClockWithPopup";
import HorizontalAccordion from "../Section/Horizontal Accordion/HorizontalAccordion";
import HorizontalAccordion1 from "../Section/Horizontal Accordion/HorizontalAccordion1";
import HorizontalSwipCard from "../Section/Horizontal Accordion/HorizontalSwipCard";
import AccordionHor from "../Section/Horizontal Accordion/AccordionHor";
import Carousel from "../Section/Horizontal Accordion/Carousel/Carousel";
import CardsScrollTest from "../Section/ThirdMainSection/StackingCardsScrollingEffect/CardsScrollTest";
import MainSecion3Backup from "../Section/ThirdMainSection/StackingCardsScrollingEffect/MainSecion3Backup";
import MainSecion3Backup2 from "../Section/ThirdMainSection/StackingCardsScrollingEffect/MainSecion3Backup2";
import StackScroll from "../Section/ThirdMainSection/StackingCardsScrollingEffect/StackScroll";
import FirstSection from "../Section/FourthMainSection/MainSectionForth/FirstSection";
import Card1 from "../Section/FourthMainSection/MainSectionForth/Card1";
import MainSection3Test from "../Section/ThirdMainSection/StackingCardsScrollingEffect/MainSection3Test";
import AutoScrollingChips from "../Section/Horizontal Accordion/AutoScrollingChips";
import IndustrieSection from "../Section/Industries/IndustrieSection";
import TestHorizonatalAccordion from "../Section/Horizontal Accordion/TestHorizonatalAccordion";
import FirstSectionII from "../Section/FourthMainSection/MainSectionForth/FirstSectionII";
import CarouselSection from "../Section/Horizontal Accordion/Carousel/CarouselSection";
import Introduction from "../Section/Horizontal Accordion/Introduction";
import BottomSection from "../Section/Horizontal Accordion/BottomSection";
import DefaultSection from "../Section/DeafultSection/Section1";
import Frame from "../Section/VerticalCardScroll/Frame";
import VerticalCardScroll from "../Section/VerticalCardScroll/VerticalCardScroll";
import MainSection from "../Section/VerticalCardScroll/MainSection";
import FrameSection from "../Section/VerticalCardScroll/FrameSection";
import Testing from "../Section/VerticalCardScroll/Testing";
import "./style.css";
import VerticalLineComponent from "../Section/VerticalCardScroll/verticalLine/VerticalLineComponent";
import MainHeroSection from "../Section/VerticalCardScroll/MainHeroSection";
import CertificateCard from "../Section/CertificateCard/CertificateCard";
import GridSection from "../Section/GirdSection/GridSection";
import PerformanceMetrics from "../Section/PerformanceMetrics/PerformanceMetrics";
import MainPerformanceMetrics from "../Section/PerformanceMetrics/MainPerformanceMetrics";
import BlogSection1 from "../Section/BlogSection/BlogSection1";
import BlogSection2 from "../Section/BlogSection/BlogSection2";
import BlogcardSection from "../Section/BlogSection/BlogcardSection";
import CustomBlankCard from "../Section/BlogSection/CustomBlankCard";
import CardAnimation from "../Section/CardStackScroll/CardAnimation";
import MainCard from "../Section/CardStackScroll/MainCard";
import TemplatesSection from "../Section/TemplateSection/Section15/TemplatesSection";
import ApiCardData from "../Section/BlogSection/ApiCardData";
import PrivacyPolicy2 from "../Section/FooterSection/PrivacyPolicy2";
import CommentSection from "../Section/BlogSection/CommentSection/CommentSection";
import CommentSection1 from "../Section/BlogSection/CommentSection/commentSection1";
import { Button, Stack } from "@mui/material";
import { FaInfoCircle, FaUserPlus } from "react-icons/fa";
import CardSliderPage from "../Section/IndustriesHeader/SevenSection/CardSlider/CardSliderPage";

const Layout = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
    if (window.location.hash) {
      // Remove any hash in the URL
      window.history.replaceState(null, null, " ");
    }
  }, []);
  const faqRef = useRef(null); // Create a reference for the FAQList component

  const scrollToFAQ = () => {
    faqRef.current?.scrollIntoView({ behavior: "smooth" }); // Scroll to FAQList component
  };

  return (
    <>
      <Header />
      <main>
        <MainHeroSection />
        <CardSliderPage />
        <MainSection2 />
        <StackScroll />
        <FirstSectionII />
        <TemplatesSection />
        <MainPerformanceMetrics />
        <div ref={faqRef}>
          <FAQList />
        </div>
        <GridSection />
        <BlogcardSection />      
        <CertificateCard />
      </main>
      <Footer onFAQClick={scrollToFAQ} />{" "}
      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-around"
        alignItems="center"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "56px",
          backgroundColor: "white",
          borderTop: "1px solid #7A7A7A",

          // px: 1,
          display: { xs: "flex", sm: "flex", md: "none" },
          zIndex: 1300,
          // border: "1px solid red",
        }}
      >
        <Button
          variant="contained"
          startIcon={<FaUserPlus />}
          sx={{
            backgroundColor: "rgb(5 78 146)",
            textTransform: "none",
            borderRadius: "8px",
            paddingLeft: "8px",
            fontSize: "0.9rem",           
            px: 3,
          }}
        >
          Sign up now 
        </Button>
        <Button
          variant="outlined"
          startIcon={<FaInfoCircle />}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            color: "rgb(5 78 146)",
            borderColor: "rgb(5 78 146)",
            fontSize: "0.9rem",
            px: 3,
          }}
        >
          Know more
        </Button>
      </Stack>
    </>
  );
};

export default Layout;






///background: "#FFE8EC"